module.exports = __webpack_public_path__ + "static/group-2@2x-bf92e218281c754881e53800f8e82ea2.png";